import { render, staticRenderFns } from "./specialTestEdit.vue?vue&type=template&id=4e635682"
import script from "./specialTestEdit.vue?vue&type=script&lang=js"
export * from "./specialTestEdit.vue?vue&type=script&lang=js"
import style0 from "./specialTestEdit.vue?vue&type=style&index=0&id=4e635682&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports